
export const PENDING_RESOLUTION = "PENDING_RESOLUTION";
export const RESOLVED = "RESOLVED";
export const EXPIRED = "EXPIRED";
export const INELIGIBLE = "INELIGIBLE";

export const ALL_TYPES = [PENDING_RESOLUTION, RESOLVED, EXPIRED, INELIGIBLE];
